import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import styles from "./gallery.module.css";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [displayedImages, setDisplayedImages] = useState([]); // For lazy loading
  // const [loading, setLoading] = useState(true);

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // const folderId =  "1OQoaDl9kb7VEAYF1m4HHkble-j_FWJs7";
        const folderMap = {
          studio: "1OQoaDl9kb7VEAYF1m4HHkble-j_FWJs7",
          moments: "1UigUDpDj_SbZ0lgIEWSdii0CYUiE5JWe",
          progress: "19RSSlEzNmcXmzlNbg192mxuPklzdM5Kq",
        };
        const routeKey = location.pathname.split("/")[1];
        const folderId = folderMap[routeKey];

        const apiKey = "AIzaSyAAgFvKs3Vo5nuo_bkIY1ePkNqNsSmB33g";

        const url = `https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents and mimeType contains 'image/'&fields=files(id,name)&key=${apiKey}`;

        const res = await axios.get(url);

        const imgs = res.data.files.map((file) => ({
          id: file.id,
          name: file.name,
          thumb: `https://lh3.googleusercontent.com/d/${file.id}=w600`, // Fast loading grid
          full: `https://lh3.googleusercontent.com/d/${file.id}=w2000`, // High quality popup
        }));

        setImages(imgs);
      } catch (err) {
        console.error("Drive fetch error:", err);
      } finally {
        // setLoading(false);
      }
    };

    fetchImages();
  }, [location.pathname]);

  // Load first 7 images, then load rest after delay
  useEffect(() => {
    if (images.length > 0) {
      // Show first 6 images immediately
      setDisplayedImages(images.slice(0, 6));

      // Load remaining images after 1 second
      if (images.length > 6) {
        setTimeout(() => {
          setDisplayedImages(images);
        }, 1000);
      }
    }
  }, [images]);



  return (
    <>
      {/* Masonry */}
      <div className={styles.masonry}>
        {displayedImages.map((img, index) => (
          <div
            key={img.id}
            className={styles.item}
            onClick={() => {
              setCurrentIndex(images.indexOf(img));
              setIsOpen(true);
            }}
          >
            <img src={img.thumb} alt={img.name} loading="lazy" />
          </div>
        ))}
      </div>

      {/* Popup */}
      {/* {isOpen && (
        <div className={styles.popup}>
          <span className={styles.close} onClick={() => setIsOpen(false)}>
            ×
          </span>

          <button
            className={styles.prev}
            onClick={() =>
              setCurrentIndex(
                (currentIndex - 1 + images.length) % images.length
              )
            }
          >
            ❮
          </button>

          <img src={images[currentIndex].url} className={styles.popupImg} />

          <button
            className={styles.next}
            onClick={() =>
              setCurrentIndex((currentIndex + 1) % images.length)
            }
          >
            ❯
          </button>
        </div>
      )} */}
      {isOpen && (
        <div className={styles.popup}>
          <span className={styles.close} onClick={() => setIsOpen(false)}>×</span>

          {/* LEFT → CLOSE */}
          <div
            className={styles.leftZone}
            onClick={() => setIsOpen(false)}
          />

          <div className={styles.lightboxFrame}>
            <img
              src={images[currentIndex].full}
              className={styles.popupImg}
              alt=""
            />
          </div>

          {/* RIGHT → CLOSE */}
          <div
            className={styles.rightZone}
            onClick={() => setIsOpen(false)}
          />

          {/* ARROWS → NAVIGATION */}
          <button
            className={styles.prev}
            onClick={() =>
              setCurrentIndex(
                (currentIndex - 1 + images.length) % images.length
              )
            }
          >
            ❮
          </button>

          <button
            className={styles.next}
            onClick={() =>
              setCurrentIndex(
                (currentIndex + 1) % images.length
              )
            }
          >
            ❯
          </button>
        </div>
      )}

    </>
  );
};

export default Gallery;
